import type { LinkedAccount } from "@store/linkedAccountSlice";
import { normalizeNameWithAt } from "@utils/util";
import { twMerge } from "tailwind-merge";
import { AccountAvatar } from "./AccountAvatar";

interface AccountIdentityProps {
  account: LinkedAccount;
  avatarSize?: number;
  className?: string;
  nameClassName?: string;
}

/** 账号「头像 + 名称」展示，供账号下拉、卡片等场景复用 */
export const AccountIdentity = ({ account, avatarSize = 20, className, nameClassName }: AccountIdentityProps) => (
  <div className={twMerge("flex min-w-0 items-center gap-[6px]", className)}>
    <AccountAvatar
      imageUrl={account.accountImage}
      name={account.accountName}
      size={avatarSize}
      placeholder="initial"
      bordered
    />
    <span className={twMerge("truncate text-[14px] leading-[20px] text-kds-fg", nameClassName)}>
      {normalizeNameWithAt(account.accountName)}
    </span>
  </div>
);
